var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgMenuDown(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 6",
    fill: "#676D7D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M11.025 1.275l-4.5 4.5A.68.68 0 016 6a.68.68 0 01-.525-.225l-4.5-4.5c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0L6 4.2 9.975.225c.3-.3.75-.3 1.05 0 .3.3.3.75 0 1.05z"
  })));
}
export default SvgMenuDown;